import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconBasket1: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconBasket1"><Path d="M1.5 2.5H3.5L4.19231 5.5M4.19231 5.5L6.5 15.5H19.5L21.5 5.5H4.19231ZM10.5 19C10.5 19.8284 9.82843 20.5 9 20.5C8.17157 20.5 7.5 19.8284 7.5 19C7.5 18.1716 8.17157 17.5 9 17.5C9.82843 17.5 10.5 18.1716 10.5 19ZM18.5 19C18.5 19.8284 17.8284 20.5 17 20.5C16.1716 20.5 15.5 19.8284 15.5 19C15.5 18.1716 16.1716 17.5 17 17.5C17.8284 17.5 18.5 18.1716 18.5 19Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconBasket1;
